module.exports = __webpack_public_path__ + "static/media/eleven.12a29eaf.svg";